import { AppState } from "features";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
	DocumentActionTypes,
	LoadDocumentById,
	LoadDocumentByIdError,
	LoadDocumentByIdSuccess,
} from "./document.action";
import { DocumentApiService } from "../../services/api/document-api.service";
import { catchError, concatMap, map } from "rxjs/operators";
import { of } from "rxjs";
import { Actions, createEffect, ofType } from "@ngrx/effects";

@Injectable()
export class DocumentEffect {
	constructor(
		private actions$: Actions,
		private documentApiService: DocumentApiService,
		private store: Store<AppState>,
	) {}

	loadDocument$ = createEffect(() =>
		this.actions$.pipe(
			ofType<LoadDocumentById>(DocumentActionTypes.LoadDocumentById),
			concatMap((action) =>
				this.documentApiService.getDocumentById(action.payload).pipe(
					map((doc) => new LoadDocumentByIdSuccess(doc)),
					catchError((err) => of(new LoadDocumentByIdError(err))),
				),
			),
		),
	);
}
